import { AlertProps } from '@material-ui/lab/Alert';

/*
 * Action Types
 */
export enum SnackbarsTypes {
  SET_OPEN = '@snackbars/SET_OPEN',
  SET_CLOSE = '@snackbars/SET_CLOSE',
  SET_SECOND_OPEN = '@snackbars/SET_SECOND_OPEN',
  SET_SECOND_CLOSE = '@snackbars/SET_SECOND_CLOSE',
}

/*
 * Data types
 */
export interface SnackbarInterface {
  open: boolean;
  message: string;
  type?: AlertProps['severity'];
  status?: number;
}

/*
 * State type
 */
export interface SnackbarsState {
  readonly snackbar: SnackbarInterface;
  readonly secondSnackbar: SnackbarInterface;
}
